
export function makeNumberOrUndefined(input: number | string | null | undefined) {
    if (input === null || input === undefined) {
        return undefined;
    }

    return Number(input);
}